<template>
  <div class="renewals-global-plans">
    <PreloaderComponent :enable="enable"></PreloaderComponent>
    <div class="content-container" v-if="enable">
      <v-card class="data-card">
        <v-card-title class="card-header">
          <v-icon left color="primary">mdi-view-grid-outline</v-icon>
          Plans d’utilisation (catalogue)
          <v-spacer></v-spacer>
          <v-chip small>{{ plans.length }} plan(s)</v-chip>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="plans"
          :items-per-page="15"
          class="modern-table"
          :loading="loading"
        >
          <template v-slot:item.amount="{ item }">
            <span class="amount-value">{{ formatNumber(item.amount) }} {{ item.currency }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip x-small :color="item.status === 'ACTIVE' ? 'success' : 'grey'" class="white--text">
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:item.duration="{ item }">
            {{ item.duration }} {{ typeLabel(item.type) }}
          </template>
          <template v-slot:item.created_at="{ item }">
            {{ item.created_at | formatDate }}
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import PreloaderComponent from '../../components/PreloaderComponent.vue'
import moment from 'moment'

export default {
  name: 'RenewalsGlobalPlansView',
  components: { PreloaderComponent },
  data() {
    return {
      enable: false,
      loading: false,
      plans: [],
      headers: [
        { text: 'CODE', value: 'plan_code' },
        { text: 'NOM', value: 'name' },
        { text: 'DURÉE', value: 'duration', sortable: false },
        { text: 'MONTANT', value: 'amount' },
        { text: 'STATUT', value: 'status' },
        { text: 'CRÉÉ LE', value: 'created_at' }
      ]
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      var self = this
      self.loading = true
      self.$axios
        .get('/subscription-plans')
        .then(function(res) {
          var data = res.data
          self.plans = Array.isArray(data) ? data : []
          self.enable = true
        })
        .catch(function() {
          self.plans = []
          self.enable = true
        })
        .finally(function() {
          self.loading = false
        })
    },
    formatNumber(v) {
      if (v == null) return '0'
      return parseInt(v, 10).toLocaleString('fr-FR')
    },
    typeLabel(t) {
      if (t === 'month') return 'mois'
      if (t === 'day') return 'jour(s)'
      return t || ''
    }
  },
  filters: {
    formatDate(v) {
      if (!v) return '—'
      return moment(v).format('DD/MM/YYYY HH:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
.renewals-global-plans {
  min-height: 100%;
}

.content-container {
  padding: 0 24px 24px;
}

.data-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.card-header {
  padding: 16px 20px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  font-weight: 600;
}

.amount-value {
  font-weight: 600;
  color: #003f74;
}

.theme--dark .amount-value {
  color: #4a90d9;
}
</style>
